import React from 'react';
import { Button } from '../ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { LP_URL } from '../../lib/utils';

export const TaxSection = () => (
  <section className="py-10 md:py-14 lg:py-16 bg-white" data-testid="tax-section">
    <div className="container-apex">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-[#007f73] font-medium mb-3 text-sm uppercase tracking-wider">Nosso Principal Diferencial</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Contabilidade tributária especializada no setor médico
          </h2>
          <p className="text-slate-600 text-lg mb-6 leading-relaxed">
            A maioria dos médicos paga mais impostos do que deveria. Isso acontece porque contabilidades 
            generalistas não conhecem as particularidades tributárias do setor de saúde.
          </p>
          <p className="text-slate-600 mb-8 leading-relaxed">
            Na Apex, somos <strong>especialistas exclusivos em tributação médica</strong>. Analisamos seu modelo 
            atual, identificamos oportunidades de economia e estruturamos seu CNPJ da forma mais vantajosa — 
            tudo dentro da lei, com total segurança jurídica.
          </p>
          <ul className="space-y-4 mb-8">
            {[
              { title: 'Enquadramento tributário otimizado', desc: 'Simples, Lucro Presumido ou Real — escolhemos o melhor para você' },
              { title: 'Planejamento fiscal preventivo', desc: 'Antecipamos cenários e evitamos surpresas desagradáveis' },
              { title: 'Revisão de oportunidades perdidas', desc: 'Identificamos créditos e deduções não aproveitados' },
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-[#007f73] mt-0.5 flex-shrink-0" />
                <div>
                  <span className="font-medium text-slate-900">{item.title}</span>
                  <p className="text-slate-600 text-sm">{item.desc}</p>
                </div>
              </li>
            ))}
          </ul>
          <Button asChild className="btn-primary rounded-md px-8">
            <a href={LP_URL} target="_blank" rel="noopener noreferrer">
              Solicitar diagnóstico tributário gratuito
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
        </div>
        <div className="relative">
          <div className="bg-gradient-to-br from-[#1e4e7e] to-[#007f73] rounded-2xl p-8 text-white">
            <h3 className="font-heading text-2xl font-bold mb-6">Como funciona nossa análise</h3>
            <div className="space-y-6">
              {[
                { step: '1', title: 'Diagnóstico gratuito', desc: 'Analisamos sua estrutura atual e identificamos oportunidades' },
                { step: '2', title: 'Proposta personalizada', desc: 'Apresentamos quanto você pode economizar e como' },
                { step: '3', title: 'Implementação segura', desc: 'Executamos a reestruturação com total compliance' },
                { step: '4', title: 'Acompanhamento contínuo', desc: 'Monitoramos e otimizamos sua situação fiscal mensalmente' },
              ].map((s) => (
                <div key={s.step} className="flex gap-4">
                  <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 font-bold">{s.step}</div>
                  <div>
                    <h4 className="font-semibold mb-1">{s.title}</h4>
                    <p className="text-white/80 text-sm">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
